/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { etoilePercentage } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_multi_004: Question = {
  id: 'multi-004-proximite-etablissements-nature',
  oldId: '65',
  title: 'Proximité des établissements scolaires, des hôpitaux et des maisons pour personnes âgées à la nature',
  number: '5.4',
  description: ['Proportion d\'établissements scolaires, d\'hôpitaux et de maisons pour personnes âgées situés à moins de 300 m d\'une aire de conservation aménagée ou d\'un parc urbain si sa superficie est couverte à plus de 50 % par de la végétation haute'],
  type: QuestionType.INDICATOR,
  frequency: 1,
  slots: [
    {
      type: SlotTypes.ETOILES,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: false,
      optional: true,
      scoringFct: (data:number) => {
        if (data >= 41) return 3;
        if (data >= 26) return 2;
        if (data >= 11) return 1;
        return 0;
      },
      score: '0',
      maxScore: 3,
      labels: ['0% - 10%', '11% - 25%', '26% - 40 %', '+ de 40 %'],
      help: etoilePercentage,
      unit: SlotUnit.PERCENTAGE,
    },
  ],
};

const question_multi_004__v3: Question = {
  ...question_multi_004,
  number: '5.3',
};
export const question_multi_004_v2: Question = question_multi_004;
export const question_multi_004_v3: Question = question_multi_004__v3;
